<ng-container
  *ngLet="{
    disabled: defaultedDisabled | async,
    selected: defaultedSelected | async,
    autoFocus: defaultedAutoFocus | async,
    indeterminate: defaultedIndeterminate | async,
    expandable: defaultedExpandable | async,
    expanded: defaultedExpanded | async,
    title: defaultedTitle | async,
    count: defaultedCount | async,
    subtitle: defaultedSubtitle | async,
    titleHighlightIndices: defaultedTitleHighlightIndices | async,
    subtitleHighlightIndices: defaultedSubtitleHighlightIndices | async,
    identifier: defaultedIdentifier | async
  } as vm"
>
  <div class="multi-select-node">
    <riv-checkbox
      class="checkbox"
      [disabled]="vm.disabled"
      [value]="vm.selected"
      (valueChange)="selectedChange.emit($event)"
      [indeterminate]="vm.indeterminate"
      [identifier]="vm.identifier"
    >
      <span
        class="label"
        [title]="getTooltip(vm.title, vm.subtitle, vm.identifier)"
      >
        <span class="label-id rv-bold" *ngIf="displayId">
          {{ vm.identifier }} -
        </span>
        <span class="label-title">
          <fuzzy-highlight
            [text]="vm.title"
            [indices]="vm.titleHighlightIndices"
          ></fuzzy-highlight>
        </span>
        <span *ngIf="vm.subtitle" class="label-subtitle">
          <fuzzy-highlight
            [text]="vm.subtitle"
            [indices]="vm.subtitleHighlightIndices"
          ></fuzzy-highlight>
        </span>
      </span>
      <span class="count">{{ vm.count | rivNumber }}</span>
    </riv-checkbox>
  </div>
</ng-container>
